import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import Notifications from 'react-notification-system-redux'
import validator from 'validator'

import { url, handleCommonEditActions, validationMessage, getPrerequisitesArray } from '../../../common/helpers'
import * as formatters from '../../../common/formatters'
import { Form, InputField, SelectField, SubmitButton } from '../../../common/form'
import { createGetTaxRateByIDSelector, createGetCurrentTaxRateStatusSelector } from '../selectors'
import * as taxRatesActionCreators from '../actionCreators'
import * as constants from '../constants'
import { LoadingOverlay } from '../../../common/loading_overlay'
import { preparePrerequisitesFetchStatusSelectors } from '../../../common/prerequisites/selectors'
import { preparePrerequisitesActionCreators } from '../../../common/prerequisites/actionCreators'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS } from '../permissions'

const componentIdentifier = 'tax_rates_edit'
const prerequisites = ['countries']

class TaxRatesEdit extends Component {
    defaultValues = {
        percent: 0,
    }

    validationRules = {
        name: value => validator.isEmpty(String(value)) && validationMessage('isEmpty'),
    }

    state = {
        values: this.defaultValues,
    }

    setValues = (values, callback) => {
        this.setState(
            {
                values,
            },
            callback
        )
    }

    handleChangeValues = values => {
        this.setValues(values)
    }

    handleSubmit = values => {
        this.setValues(values, () => {
            this.handleSave()
        })
    }

    handleSave = () => {
        this.props.actions.saveTaxRate(this.state.values)
    }

    componentDidMount() {
        this.props.match.params.taxRateID && this.props.actions.fetchTaxRate(this.props.match.params.taxRateID)
        this.props.actions.fetchPrerequisites()
    }

    componentWillReceiveProps(nextProps) {
        handleCommonEditActions(this.props, nextProps, () => {
            this.props.redirect(url(this.props.match, 'tax-rates'))
        })

        if (JSON.stringify(nextProps.taxRate) !== JSON.stringify(this.props.taxRate) || (nextProps.taxRate && !this.state.values.id)) {
            this.setValues(nextProps.taxRate.toJS())
        }
    }

    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.taxRates.heading' }))

        const taxRateTypesOptions = [
            {
                id: constants.TAX_RATE_TYPE_BASIC,
                name: this.props.intl.formatMessage({ id: `taxRateTypes.${constants.TAX_RATE_TYPE_BASIC}` }),
            },
            {
                id: constants.TAX_RATE_TYPE_FIRST_REDUCED,
                name: this.props.intl.formatMessage({ id: `taxRateTypes.${constants.TAX_RATE_TYPE_FIRST_REDUCED}` }),
            },
            {
                id: constants.TAX_RATE_TYPE_SECOND_REDUCED,
                name: this.props.intl.formatMessage({ id: `taxRateTypes.${constants.TAX_RATE_TYPE_SECOND_REDUCED}` }),
            },
            {
                id: constants.TAX_RATE_TYPE_ZERO,
                name: this.props.intl.formatMessage({ id: `taxRateTypes.${constants.TAX_RATE_TYPE_ZERO}` }),
            },
        ]

        return (
            <PermissionsCheck hasAny={Object.values(PERMS)} noPermissionsPage>
                <div className="page-inner">
                    <div id="main-wrapper">
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4">
                                <div className="panel panel-white">
                                    <div className="panel-body panel-padding">
                                        <div className="panel-head">
                                            <h4>
                                                <FormattedMessage id="modules.taxRates.heading" /> -{' '}
                                                {this.props.taxRate ? (
                                                    <FormattedMessage id="fields.itemEdit" />
                                                ) : (
                                                    <FormattedMessage id="fields.itemCreate" />
                                                )}
                                            </h4>
                                        </div>
                                        <LoadingOverlay active={this.props.prerequisites.status.get('fetching') || this.props.status.get('fetching')}>
                                            <PermissionsCheck hasAny={Object.values(PERMS)}>
                                                <Form
                                                    values={this.state.values}
                                                    validationRules={this.validationRules}
                                                    onChange={this.handleChangeValues}
                                                    onSubmit={this.handleSubmit}
                                                    isEdit={Boolean(this.props.taxRate)}
                                                >
                                                    <InputField
                                                        id="name"
                                                        label={this.props.intl.formatMessage({ id: 'fields.name' })}
                                                        className="wp-50"
                                                    />
                                                    <SelectField
                                                        id="country_id"
                                                        label={this.props.intl.formatMessage({ id: 'fields.country' })}
                                                        values={getPrerequisitesArray(this.props.prerequisites.values.get('countries'), 'id', 'iso_code')}
                                                        className="wp-50"
                                                    />
                                                    <SelectField
                                                        id="type_id"
                                                        label={this.props.intl.formatMessage({ id: 'fields.taxRateType' })}
                                                        values={taxRateTypesOptions}
                                                        className="wp-50"
                                                    />
                                                    <InputField
                                                        id="percent"
                                                        label={`${this.props.intl.formatMessage({ id: 'fields.value' })} [%]`}
                                                        className="wp-20"
                                                    />

                                                    <div className="btns-form">
                                                        <Link to={url(this.props.match, 'tax-rates')} className="btn btn-addon btn-default">
                                                            <i className="far fa-chevron-left" /> <FormattedMessage id="buttons.back" />
                                                        </Link>
                                                        <SubmitButton
                                                            perms={Object.values(PERMS)}
                                                            isEdit={Boolean(this.props.taxRate)}
                                                            className="btn-addon pull-right"
                                                        />
                                                    </div>
                                                </Form>
                                            </PermissionsCheck>
                                        </LoadingOverlay>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PermissionsCheck>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        taxRate: createGetTaxRateByIDSelector(ownProps.match.params.taxRateID)(state),
        status: createGetCurrentTaxRateStatusSelector()(state),
        prerequisites: preparePrerequisitesFetchStatusSelectors(componentIdentifier, prerequisites, state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators(
                {
                    ...taxRatesActionCreators,
                    ...preparePrerequisitesActionCreators(componentIdentifier, prerequisites),
                },
                dispatch
            ),
        },
        redirect: toURL => dispatch(push(toURL)),
        notify: (notification, type) => dispatch(Notifications.show(notification, type)),
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(TaxRatesEdit)
)
